var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "groupContainer" },
    [
      _c(
        "v-form",
        {
          ref: "topscrollForm",
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-row",
            { staticClass: "pb-3" },
            [
              _c(
                "v-col",
                {
                  staticStyle: { height: "64px" },
                  attrs: { cols: "12", xs: "12" }
                },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { absolute: "", id: "adnm-format-toolbar" } },
                    [
                      _c(
                        "v-toolbar-title",
                        { staticClass: "body-2 grey--text" },
                        [
                          _vm._v(
                            "Campaign type: " +
                              _vm._s(_vm.campaignTypeLable.get(_vm.Ad.type))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "info",
                            href:
                              _vm.rmbPath + _vm.Ad.creativeCode + "/tags.txt",
                            target: "_blank",
                            disabled: !_vm.Ad.published
                          }
                        },
                        [_vm._v("Tags")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-6",
                          attrs: {
                            color: "info",
                            href: _vm.getPreviewPath(_vm.Ad),
                            target: "_blank",
                            disabled: !_vm.Ad.published
                          }
                        },
                        [_vm._v("Preview")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-6",
                          attrs: { color: "success", disabled: !_vm.valid },
                          on: { click: _vm.saveAdFormat }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        staticClass: "ml-6",
                                        attrs: {
                                          icon: "",
                                          color: "primary",
                                          disabled: !_vm.publishPossible,
                                          loading: _vm.publishLoading
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.publishAd()
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "loader",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "custom-loader"
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { light: "" }
                                                        },
                                                        [_vm._v("mdi-cached")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { dark: "", color: "white" } },
                                        [_vm._v("mdi-flash-outline")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [_vm._v("\n            Put changes live\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-6 icon-button",
                          attrs: { disabled: false },
                          on: { click: _vm.closeAdFormat },
                          scopedSlots: _vm._u([
                            {
                              key: "loader",
                              fn: function() {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "custom-loader" },
                                    [
                                      _c("v-icon", { attrs: { light: "" } }, [
                                        _vm._v("mdi-cached")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { attrs: { align: "start", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "12", md: "10", xl: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      dense: "",
                      typeof: "text",
                      label: "Creative Code",
                      rules: [_vm.input.required],
                      disabled: _vm.notUnstableFormat
                    },
                    model: {
                      value: _vm.Ad.creativeCode,
                      callback: function($$v) {
                        _vm.$set(_vm.Ad, "creativeCode", $$v)
                      },
                      expression: "Ad.creativeCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.Ad.dateCreated
            ? _c(
                "v-row",
                { attrs: { align: "start", justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12", md: "10", xl: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          typeof: "text",
                          label: "Created date",
                          disabled: _vm.notUnstableFormat
                        },
                        model: {
                          value: _vm.dateCreated,
                          callback: function($$v) {
                            _vm.dateCreated = $$v
                          },
                          expression: "dateCreated"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.Ad.dateLastChanged
            ? _c(
                "v-row",
                { attrs: { align: "start", justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12", md: "10", xl: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          typeof: "text",
                          label: "Updated date",
                          disabled: _vm.notUnstableFormat
                        },
                        model: {
                          value: _vm.dateLastChanged,
                          callback: function($$v) {
                            _vm.dateLastChanged = $$v
                          },
                          expression: "dateLastChanged"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", md: "2", xl: "3" } },
                [
                  _c("v-flex", { staticClass: "caption pt-1 pl-1" }, [
                    _vm._v("\n          Organization\n        ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", md: "10", xl: "6" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "start", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("organization-selector", {
                            attrs: {
                              id: "organization-filter-input",
                              isAdvertiserSearch: false,
                              required: true
                            },
                            model: {
                              value: _vm.Ad.organization,
                              callback: function($$v) {
                                _vm.$set(_vm.Ad, "organization", $$v)
                              },
                              expression: "Ad.organization"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.Ad.id
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("organization-selector", {
                                attrs: {
                                  id: "organization-filter-input",
                                  isAdvertiserSearch: true,
                                  disabled: !_vm.Ad.organizationId,
                                  parent: _vm.Ad.organization,
                                  required: true
                                },
                                model: {
                                  value: _vm.Ad.advertiser,
                                  callback: function($$v) {
                                    _vm.$set(_vm.Ad, "advertiser", $$v)
                                  },
                                  expression: "Ad.advertiser"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", md: "2", xl: "3" } },
                [
                  _c("v-flex", { staticClass: "caption pt-1 pl-1" }, [
                    _vm._v("\n          General info\n        ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", md: "10", xl: "6" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "start", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              label: "Campaign name",
                              rules: [_vm.input.required],
                              clearable: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.onInputChanged()
                              }
                            },
                            model: {
                              value: _vm.Ad.campaignName,
                              callback: function($$v) {
                                _vm.$set(_vm.Ad, "campaignName", $$v)
                              },
                              expression: "Ad.campaignName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { align: "start", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              dense: "",
                              "auto-grow": "",
                              label: "Description",
                              clearable: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.onInputChanged()
                              }
                            },
                            model: {
                              value: _vm.Ad.description,
                              callback: function($$v) {
                                _vm.$set(_vm.Ad, "description", $$v)
                              },
                              expression: "Ad.description"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { align: "start", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("country-selector", {
                            attrs: {
                              id: "country-filter-input",
                              placeholder: "Type in country"
                            },
                            on: { input: _vm.countryChosen },
                            model: {
                              value: _vm.Ad.countryModel,
                              callback: function($$v) {
                                _vm.$set(_vm.Ad, "countryModel", $$v)
                              },
                              expression: "Ad.countryModel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", md: "2", xl: "3" } },
                [
                  _c("v-flex", { staticClass: "caption pt-1 pl-1" }, [
                    _vm._v("\n          Campaign settings\n        ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", md: "10", xl: "6" } },
                [
                  !_vm.IsSectionAvailable([
                    _vm.campaignType.inread_expander,
                    _vm.campaignType.unstable_format_template,
                    _vm.campaignType.hosting
                  ])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  label: "Click URL",
                                  rules: [_vm.input.required],
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value: _vm.Ad.clickUrl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.Ad, "clickUrl", $$v)
                                  },
                                  expression: "Ad.clickUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([_vm.campaignType.inread_expander])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  label: "Micro site URL",
                                  rules: [_vm.input.required],
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.micrositeUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel,
                                      "micrositeUrl",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.micrositeUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([
                    _vm.campaignType.topscroll,
                    _vm.campaignType.topscroll_desktop_image,
                    _vm.campaignType.html_topscroll,
                    _vm.campaignType.topscroll_desktop_html,
                    _vm.campaignType.video_topscroll,
                    _vm.campaignType.topscroll_desktop_video
                  ])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  dense: "",
                                  items: _vm.topscrollHeightInput,
                                  "item-text": "value",
                                  "item-value": "key",
                                  label: "Height",
                                  rules: [_vm.input.required]
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .topscrollHeight,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "topscrollHeight",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.topscrollHeight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([
                    _vm.campaignType.desktop_html_interscroll,
                    _vm.campaignType.video_desktop_interscroll
                  ])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  dense: "",
                                  items: _vm.relativeHeightInput,
                                  "item-text": "value",
                                  "item-value": "key",
                                  label: "Height",
                                  rules: [_vm.input.required]
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .relativeHeight,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "relativeHeight",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.relativeHeight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([
                    _vm.campaignType.skin,
                    _vm.campaignType.sideskin,
                    _vm.campaignType.desktop_interscroll,
                    _vm.campaignType.adform_vskin,
                    _vm.campaignType.video_skin,
                    _vm.campaignType.unstable_format_template,
                    _vm.campaignType.hosting
                  ])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", xs: "12", md: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  label: "Width in pixels",
                                  rules: [
                                    _vm.input.required,
                                    _vm.input.number,
                                    _vm.input.largerThanZero
                                  ],
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .width,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "width",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.width"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", xs: "12", md: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  label: "Height in pixels",
                                  rules: [
                                    _vm.input.required,
                                    _vm.input.number,
                                    _vm.input.largerThanZero
                                  ],
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .height,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "height",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.height"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([_vm.campaignType.hosting])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", xs: "12" } },
                            [
                              _c("v-textarea", {
                                attrs: { label: "HTML" },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .html,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "html",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.html"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-textarea", {
                                attrs: { label: "CSS" },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .css,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "css",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.css"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-textarea", {
                                attrs: { label: "JavaScript" },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .javascript,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "javascript",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.javascript"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([
                    _vm.campaignType.mobil_interscroll,
                    _vm.campaignType.html_interscroll,
                    _vm.campaignType.vertical_video_interscroll,
                    _vm.campaignType.desktop_fullscreen_interscroll
                  ])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", xs: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  label: "Height in pixels",
                                  rules: [
                                    _vm.input.required,
                                    _vm.input.number,
                                    _vm.input.largerThanZero
                                  ],
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onInputChanged()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.Ad.buildConfigurationModel.configuration
                                      .height,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Ad.buildConfigurationModel
                                        .configuration,
                                      "height",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Ad.buildConfigurationModel.configuration.height"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([
                    _vm.campaignType.html_topscroll,
                    _vm.campaignType.topscroll_desktop_html,
                    _vm.campaignType.video_topscroll,
                    _vm.campaignType.html_interscroll,
                    _vm.campaignType.vertical_video_interscroll,
                    _vm.campaignType.desktop_html_interscroll,
                    _vm.campaignType.video_desktop_interscroll,
                    _vm.campaignType.topscroll_desktop_video,
                    _vm.campaignType.fullpage_overlay_mobile_html,
                    _vm.campaignType.fullpage_overlay_desktop_html
                  ])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", xs: "12" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "", label: "Interaction:" },
                                  on: {
                                    change: function($event) {
                                      return _vm.onInputChanged()
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.Ad.buildConfigurationModel
                                        .configuration.interactionEnabled,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.Ad.buildConfigurationModel
                                          .configuration,
                                        "interactionEnabled",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "Ad.buildConfigurationModel.configuration.interactionEnabled"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Disabled", value: "false" }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "Enabled", value: "true" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    { attrs: { icon: "" } },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color:
                                                            "grey lighten-1"
                                                        }
                                                      },
                                                      [_vm._v("mdi-help")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3522972398
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                  When enabled users can interact directly with the banner, allowing users to enable/disable sound.\n                "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsSectionAvailable([
                    _vm.campaignType.video_topscroll,
                    _vm.campaignType.video_desktop_interscroll,
                    _vm.campaignType.topscroll_desktop_video
                  ])
                    ? _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", xs: "12" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "", label: "Video scaling:" },
                                  on: {
                                    change: function($event) {
                                      return _vm.onInputChanged()
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.Ad.buildConfigurationModel
                                        .configuration.letterbox,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.Ad.buildConfigurationModel
                                          .configuration,
                                        "letterbox",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "Ad.buildConfigurationModel.configuration.letterbox"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Letterbox", value: "true" }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Pillarbox",
                                      value: "false"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    { attrs: { icon: "" } },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color:
                                                            "grey lighten-1"
                                                        }
                                                      },
                                                      [_vm._v("mdi-help")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3522972398
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                  Letterbox: The video loaded will have 100% width. "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                  Pillarbox: The height of the video will be prioritized over width to ensure that the entire video can be seen.\n                "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          !_vm.IsSectionAvailable([
            _vm.campaignType.unstable_format_template,
            _vm.campaignType.hosting
          ])
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", md: "2", xl: "3" } },
                    [
                      _c("v-flex", { staticClass: "caption pt-1 pl-1" }, [
                        _vm._v("\n          Third party tags\n        ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", xs: "12", md: "10", xl: "6" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "start", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "mx-auto",
                                  attrs: { outlined: "", elevation: "4" }
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    { attrs: { "single-line": "" } },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "subtitle-2" },
                                            [
                                              _vm._v(
                                                "List of all third party tags associated with this campaign"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "" },
                                          on: { click: _vm.addThirdPartyTag }
                                        },
                                        [_c("v-icon", [_vm._v("mdi-plus")])],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-simple-table", {
                                    staticClass: "px-2 pb-2",
                                    attrs: { dense: "", "fixed-header": "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function() {
                                            return [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [_vm._v("Type")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [_vm._v("Definition")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("th")
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                [
                                                  _vm._l(
                                                    _vm.Ad
                                                      .buildConfigurationModel
                                                      .thirdPartyTags,
                                                    function(tag, index) {
                                                      return _vm.Ad
                                                        .buildConfigurationModel
                                                        .thirdPartyTags &&
                                                        _vm.Ad
                                                          .buildConfigurationModel
                                                          .thirdPartyTags
                                                          .length > 0
                                                        ? _c(
                                                            "tr",
                                                            { key: index },
                                                            [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.tagTypeLable.get(
                                                                      tag.type
                                                                    )
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "thirdPartyTag"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      tag.tag
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-right"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        icon: ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteThirdPartyTag(
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-delete"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        icon: ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.editThirdPartyTag(
                                                                            index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-pencil-outline"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.Ad
                                                    .buildConfigurationModel
                                                    .thirdPartyTags ||
                                                  _vm.Ad.buildConfigurationModel
                                                    .thirdPartyTags.length <= 0
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            attrs: {
                                                              colspan: "3"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No tags added yet"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      3777737832
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.validTags
                                ? _c(
                                    "v-flex",
                                    { staticClass: "v-messages error--text" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.validTagsMessage) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.IsSectionAvailable([
            _vm.campaignType.sideskin,
            _vm.campaignType.html_topscroll,
            _vm.campaignType.topscroll_desktop_html,
            _vm.campaignType.desktop_html_interscroll,
            _vm.campaignType.html_interscroll,
            _vm.campaignType.unstable_format_template,
            _vm.campaignType.fullpage_overlay_mobile_html,
            _vm.campaignType.fullpage_overlay_desktop_html
          ])
            ? _c(
                "v-flex",
                [
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", xs: "12", md: "2", xl: "3" } },
                        [
                          _c("v-flex", { staticClass: "caption pt-1 pl-1" }, [
                            _vm._v("\n            Assets\n          ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", xs: "12", md: "10", xl: "6" } },
                        [
                          _vm.Ad.id <= 0 || _vm.Ad.id === undefined
                            ? _c("v-col", { attrs: { cols: "12" } }, [
                                _vm._v(
                                  "\n            Assets can only be added, when the format has been saved\n          "
                                )
                              ])
                            : _c(
                                "v-row",
                                {
                                  attrs: { align: "start", justify: "center" }
                                },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _vm.warning
                                        ? _c(
                                            "v-alert",
                                            { attrs: { type: "warning" } },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(_vm.warning) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "mx-auto",
                                          attrs: {
                                            outlined: "",
                                            elevation: "4"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item",
                                            { attrs: { "single-line": "" } },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass: "subtitle-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "List of all assets associated with this campaign"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-simple-table", {
                                            staticClass: "px-2 pb-2",
                                            attrs: {
                                              dense: "",
                                              "fixed-header": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function() {
                                                    return [
                                                      _c("thead", [
                                                        _c("tr", [
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "text-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Asset type"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "text-left"
                                                            },
                                                            [_vm._v("Filename")]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.IsSectionAvailable(
                                                            [
                                                              _vm.campaignType
                                                                .hosting
                                                            ]
                                                          )
                                                            ? _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-left"
                                                                },
                                                                [_vm._v("Path")]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.IsSectionAvailable(
                                                            [
                                                              _vm.campaignType
                                                                .hosting
                                                            ]
                                                          )
                                                            ? _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-left"
                                                                },
                                                                [_vm._v("Used")]
                                                              )
                                                            : _vm._e()
                                                        ])
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "tbody",
                                                        [
                                                          _vm._l(
                                                            _vm.orderedAssets,
                                                            function(
                                                              asset,
                                                              index
                                                            ) {
                                                              return !_vm.IsSectionAvailable(
                                                                [
                                                                  _vm
                                                                    .campaignType
                                                                    .hosting
                                                                ]
                                                              )
                                                                ? _c(
                                                                    "tr",
                                                                    {
                                                                      key:
                                                                        asset.id
                                                                    },
                                                                    [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .assetType[
                                                                              asset
                                                                                .type
                                                                            ]
                                                                          )
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            asset.fileName
                                                                          )
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        [
                                                                          asset.isActive
                                                                            ? _c(
                                                                                "v-flex",
                                                                                [
                                                                                  _vm._v(
                                                                                    "X"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.orderedAssets,
                                                            function(
                                                              asset,
                                                              index
                                                            ) {
                                                              return _vm.IsSectionAvailable(
                                                                [
                                                                  _vm
                                                                    .campaignType
                                                                    .hosting
                                                                ]
                                                              )
                                                                ? _c(
                                                                    "tr",
                                                                    {
                                                                      key:
                                                                        asset.id
                                                                    },
                                                                    [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .assetType[
                                                                              asset
                                                                                .type
                                                                            ]
                                                                          )
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            asset.fileName
                                                                          )
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      asset.type !=
                                                                      _vm
                                                                        .assetType
                                                                        .banner
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.assetPath +
                                                                                    _vm
                                                                                      .Ad
                                                                                      .creativeCode +
                                                                                    "/" +
                                                                                    encodeURI(
                                                                                      asset.fileName
                                                                                    )
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.orderedAssets
                                                            .length <= 0
                                                            ? _c("tr", [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    attrs: {
                                                                      colspan:
                                                                        "3"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "No assets added yet"
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              808543196
                                            )
                                          }),
                                          _vm._v(" "),
                                          _vm.Ad.id > 0
                                            ? _c(
                                                "v-list-item",
                                                {
                                                  attrs: { "single-line": "" }
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _vm.IsSectionAvailable(
                                                            [
                                                              _vm.campaignType
                                                                .adform_vskin,
                                                              _vm.campaignType
                                                                .video_skin,
                                                              _vm.campaignType
                                                                .skin,
                                                              _vm.campaignType
                                                                .desktop_interscroll,
                                                              _vm.campaignType
                                                                .topscroll,
                                                              _vm.campaignType
                                                                .topscroll_desktop_image,
                                                              _vm.campaignType
                                                                .desktop_fullscreen_interscroll,
                                                              _vm.campaignType
                                                                .mobil_interscroll,
                                                              _vm.campaignType
                                                                .hosting
                                                            ]
                                                          )
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    xs: "12",
                                                                    xl: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-file-input",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Add image",
                                                                        accept:
                                                                          "image/*",
                                                                        loading:
                                                                          _vm.uploadImageLoading,
                                                                        "show-size":
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          _vm.imageFileChanged
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.IsSectionAvailable(
                                                            [
                                                              _vm.campaignType
                                                                .adform_vskin,
                                                              _vm.campaignType
                                                                .video_skin,
                                                              _vm.campaignType
                                                                .inread_expander,
                                                              _vm.campaignType
                                                                .video_topscroll,
                                                              _vm.campaignType
                                                                .topscroll_desktop_video,
                                                              _vm.campaignType
                                                                .vertical_video_interscroll,
                                                              _vm.campaignType
                                                                .hosting,
                                                              _vm.campaignType
                                                                .video_desktop_interscroll
                                                            ]
                                                          )
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    xs: "12",
                                                                    xl: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-file-input",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Add video",
                                                                        accept:
                                                                          "video/*",
                                                                        loading:
                                                                          _vm.uploadVideoLoading,
                                                                        "show-size":
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          _vm.videoFileChanged
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(
                                        "\n\n              " +
                                          _vm._s(_vm.validTagsMessage) +
                                          "\n            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.thirdPartyTagDialog
        ? _c("popupDialog", { attrs: { dialogModel: _vm.thirdPartyTagDialog } })
        : _vm._e(),
      _vm._v(" "),
      _vm.unsavedChangesAlertPreview
        ? _c("popupDialog", {
            attrs: { dialogModel: _vm.unsavedChangesAlertPreview }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-overlay",
        { attrs: { value: _vm.overlayShown } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", color: "primary" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }